import React from 'react';

import { Logo } from '../../icons/Logo';

import { ModalHeaderContainer } from './ModalHeaderComponentStyle';

export const ModalHeaderComponent = ({ urlRewritten, partner, i18n }) => {
    return (
        <ModalHeaderContainer className="flex-container-h flex-center-alt">
            <Logo />
            {partner && urlRewritten && (
                <div>
                    {i18n.HEADER_MSG}
                    <a href={urlRewritten} title={partner ? partner.name : ''}>
                        {i18n.CLICK_HERE}
                    </a>
                </div>
            )}
        </ModalHeaderContainer>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/ModalHeaderComponent.js